import { render, staticRenderFns } from "./VectorWidget.vue?vue&type=template&id=ea2decac&scoped=true&"
import script from "./VectorWidget.vue?vue&type=script&lang=js&"
export * from "./VectorWidget.vue?vue&type=script&lang=js&"
import style0 from "./VectorWidget.vue?vue&type=style&index=0&id=ea2decac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2decac",
  null
  
)

export default component.exports